import { resizeMode, ICellConfig } from "./types";

export function getResizeMode(isXLayout: boolean, conf1: ICellConfig, conf2: ICellConfig) {
	const field = isXLayout ? "width" : "height";

	const is1perc = conf1[field] && (conf1[field] as string).includes("%");
	const is2perc = conf2[field] && (conf2[field] as string).includes("%");
	const is1px = conf1[field] && (conf1[field] as string).includes("px");
	const is2px = conf2[field] && (conf2[field] as string).includes("px");

	if (is1perc && is2perc) {
		return resizeMode.percents;
	}
	if (is1px && is2px) {
		return resizeMode.pixels;
	}
	if (is1px && !is2px) {
		return resizeMode.mixedpx1;
	}
	if (is2px && !is1px) {
		return resizeMode.mixedpx2;
	}
	if (is1perc) {
		return resizeMode.mixedperc1;
	}
	if (is2perc) {
		return resizeMode.mixedperc2;
	}
	return resizeMode.unknown;
}

export function getBlockRange(block1: ClientRect, block2: ClientRect, isXLayout = true) {
	if (isXLayout) {
		return {
			min: block1.left + window.pageXOffset,
			max: block2.right + window.pageXOffset,
		};
	}
	return {
		min: block1.top + window.pageYOffset,
		max: block2.bottom + window.pageYOffset,
	};
}

export function getMarginSize(config: ICellConfig, xLayout: boolean) {
	if (!config) {
		return 0;
	}
	if (config.type === "space" || (config.type === "wide" && xLayout)) {
		return 10;
	}
	return 0;
}
